export function documentReviewUrl(organizationId: string | undefined, suffix = '') {
  return `/api/v1/organizations/${encodeURIComponent(organizationId ?? '')}/document-review${suffix}`;
}
